module.exports = __webpack_public_path__ + "static/media/21.ce72df60.jpg";